import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import P2Blurbs from "components/UI/P2Blurbs/P2Blurbs";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import { Grid } from "@mui/material";
import { AIExplanationNoHighlights } from "components/Evaluation/Views/Modules/AIExplanations/AIExplanationNoHighlights";
import { WorkflowReviewStore } from "../Stores/WorkflowReviewStore";
import theme from "Theme/AppTheme";

interface AIExplanationEddyContextProps {
    tagId: string;
}

const WFRAIExplanationEddyContext = observer(
    (props: AIExplanationEddyContextProps) => {
        const store = useStore(WorkflowReviewStore);

        const isLoading = store.explanationLoadingStates[props.tagId];

        if (isLoading)
            return (
                <AcxLoadingIndicator
                    color="secondary"
                    alternate="PuffLoader"
                    size={32}
                    key={"spinner" + props.tagId}
                />
            );

        const data = store.eddyEffectP2Data;

        if (!data || data.length <= 0) return <AIExplanationNoHighlights />;

        return (
            <Grid item sx={{ padding: "10px" }}>
                {(store.transcriptionData?.words ||
                    store.transcriptionData?.phrases) && (
                    <P2Blurbs
                        transcription={
                            store.transcriptionData.phrases ??
                            store.transcriptionData.words
                        }
                        data={data}
                        blurbClassName={undefined} // will set below
                        sxBlurb={{ padding: theme.spacing(1, 1.5) }}
                        isPhrasesTranscript={!!store.transcriptionData.phrases}
                        variant="eddy"
                    />
                )}
                {store.chatTranscription && (
                    <P2Blurbs
                        chat={store.chatTranscription}
                        data={data}
                        blurbClassName={undefined} // will set below
                        sxBlurb={{ padding: theme.spacing(1, 1.5) }}
                        variant="eddy"
                    />
                )}
            </Grid>
        );
    },
);

export default WFRAIExplanationEddyContext;
